import { render, staticRenderFns } from "./UnhandledRecruitmentNotificationItem.vue?vue&type=template&id=5a341315&scoped=true&"
import script from "./UnhandledRecruitmentNotificationItem.vue?vue&type=script&lang=ts&"
export * from "./UnhandledRecruitmentNotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./UnhandledRecruitmentNotificationItem.vue?vue&type=style&index=0&id=5a341315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a341315",
  null
  
)

/* custom blocks */
import block0 from "./UnhandledRecruitmentNotificationItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports